<template>
  <div style="min-height: 100vh; position: relative">
    <div
      v-if="!selectedBot.status"
      style="
        position: absolute;
        z-index: 2;
        background-color: #ecececbd;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
      "
    >
      <div class="text-xs-center mt-5 pt-5" style="margin-bottom: 25px">
        <v-card max-width="600" style="margin: auto">
          <v-card-text>
            <h3 style="text-shadow: 1px 1px 20px #9e9e9e" class="display-1">
              {{ $t('If you want to test, please activate your bot') }}
            </h3>
            <p>
              {{ $t('Information will not be recorded in analytics if the bot is inactivated') }}
            </p>

            <v-btn
              depressed
              style="margin-bottom: 1.5em"
              small
              color="primary"
              @click="toggleBotStatus"
              >{{ $t('Click for starting your Bot') }}</v-btn
            >
          </v-card-text>
        </v-card>
      </div>
    </div>

    <v-layout wrap>
      <v-flex xs12 sm12 md12>
        <div class="pa-1">
          <v-card>
            <v-card-title>
              <v-layout>
                <v-flex>
                  <template v-if="type == 'inbox'">
                    {{ $t('Conversation') }}
                  </template>
                  <template v-else-if="type == 'comment'">
                    <template v-if="commenttype == 'replycomment'">
                      {{ $t('Reply to comment') }}
                    </template>
                    <template v-else-if="commenttype == 'replyinbox'">
                      {{ $t('Reply to inbox') }}
                    </template>
                    <template v-else-if="commenttype == 'hidecomment'">
                      {{ $t('Hide comment') }}
                    </template>
                  </template>
                </v-flex>
                <v-flex class="text-xs-right">
                  <!-- <v-btn small outline color="primary">{{$t('Export')}}</v-btn> -->
                </v-flex>
              </v-layout>
            </v-card-title>

            <dashboard-graph-loading v-if="loading"></dashboard-graph-loading>

            <div style="max-width: 350px; margin: auto">
              <apexchart
                ref="intent"
                type="pie"
                :options="intent"
                :series="intentSeries.data"
                style="margin: auto"
              ></apexchart>
            </div>
            <v-divider></v-divider>
            <v-data-table
              :pagination.sync="pagination"
              :headers="intentHeaders"
              :items="intentChartData"
              :rows-per-page-items="[10, 25, 45, { text: $t('All'), value: -1 }]"
              :rows-per-page-text="$t('Rows per page')"
            >
              <template #items="props">
                <td>
                  <v-avatar :color="props.item.color" size="15"></v-avatar>
                </td>
                <td>
                  {{ intentLabel(props.item.name) }}
                </td>
                <td>{{ props.item.value | numberFormat }}</td>
                <td>
                  <v-btn
                    fab
                    icon
                    small
                    flat
                    color="grey"
                    @click="openIntentDetail(props.item.name)"
                  >
                    <v-icon>search</v-icon>
                  </v-btn>
                </td>
              </template>

              <template slot="no-data">
                <div class="text-xs-center">{{ $t('No conversation') }}</div>
              </template>
            </v-data-table>
          </v-card>
        </div>
      </v-flex>
    </v-layout>

    <v-dialog v-if="currentIntent" v-model="showIntent" scrollable>
      <v-card>
        <v-card-title>
          {{ intentLabel(currentIntent) }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 300px" class="pa-0">
          <div v-if="loadingIntent">
            <div style="padding: 30px 0">
              <v-progress-circular indeterminate color="primary"></v-progress-circular>
            </div>
          </div>
          <div v-else-if="filterIntentDetail.length <= 0">
            <div class="text-xs-center" style="margin: 35px 0">
              <img src="/static/img/assets/setting/conversation.png" alt style="width: 230px" />
              <h3>{{ $t('Not found any chatlog') }}</h3>
              <!-- <p>test</p> -->
            </div>
          </div>
          <div v-else>
            <template v-if="intentDetails && intentDetails.length">
              <v-data-table :headers="modalIntentHeader" :items="intentDetails" hide-actions>
                <template #items="props">
                  <!-- <td>{{ props.item.name }}</td> -->
                  <td style="word-break: break-word">
                    {{ props.item.questiondata ? props.item.questiondata : $t('Other') }}
                  </td>
                  <td class="text-xs-center">{{ props.item.count | numberFormat }}</td>
                </template>
              </v-data-table>

              <div v-if="$store.getters.getPackage != 'premium'" class="text-xs-center mt-5 mb-3">
                <h3 class="headline" style="text-shadow: 1px 1px 20px #9e9e9e">
                  {{ $t('Its time to upgrade.') }}
                </h3>
                <p style="text-shadow: 1px 1px 20px #9e9e9e">
                  {{ $t('Upgrade Your Plan to use PREMIUM features , only 500 THB/month') }}
                </p>
                <v-btn
                  v-if="selectedBot.pagetype != 'enterprise'"
                  depressed
                  color="primary"
                  :to="'/' + $i18n.locale() + '/upgrade'"
                  >{{ $t('Upgrade to Premium Plan') }}</v-btn
                >
              </div>
            </template>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outline color="grey" @click="showIntent = false">{{ $t('cancel') }}</v-btn>
          <v-btn v-if="currentIntent == '{default}'" depressed color="primary" :to="trainingUrl">{{
            $t('Training')
          }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import VueApexCharts from 'vue-apexcharts'
import DashboardGraphLoading from '../DashboardGraphLoading'
import api from '@/api'
import moment from 'moment'

export default {
  components: {
    DashboardGraphLoading,
    apexchart: VueApexCharts
    // StatCard
  },
  props: [
    'intentSeries',
    'intentChartData',
    'intentDetails',
    'type',
    'date',
    'app',
    'commenttype',
    'fbpost'
  ],
  data: function () {
    return {
      total: 0,
      loading: false,
      loadingThaiUnion: false,
      loadingIntent: false,
      showIntent: false,
      filter: 'all',
      currentIntent: undefined,
      currentIntentIndex: undefined,
      intentChart: undefined,
      modalIntentHeader: [
        { text: this.$t('customer says'), value: 'questiondata' },
        { text: this.$t('Count'), value: 'count', align: 'center' }
      ],
      intentHeaders: [
        { text: '', value: '', sortable: false },
        { text: this.$t('Conversation'), value: 'name' },
        { text: this.$t('Count'), value: 'value' },
        { text: '', value: 'view', sortable: false }
      ],
      pagination: { sortBy: 'value', descending: true, rowsPerPage: 10 },
      commentPagination: { sortBy: 'value', descending: true, rowsPerPage: 10 },

      intent: {
        chart: {
          type: 'donut',
          height: 350
        },
        labels: [],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                // width: 200
              },
              legend: {
                position: 'bottom'
              }
            }
          }
        ],
        dataLabels: {
          enabled: true
        },
        legend: {
          show: false
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    filterIntentDetail: function () {
      var vm = this
      return vm.intentDetails.sort(function (a, b) {
        if (a.training == true && b.training != true) {
          return 1
        }
        if (a.training != true && b.training == true) {
          return -1
        }

        return 0
      })
    },
    trainingUrl: function () {
      return (
        '/' +
        this.currentLang +
        '/training?datefrom=' +
        moment(this.date.start).format('YYYY-MM-DD') +
        '&dateto=' +
        moment(this.date.end).format('YYYY-MM-DD')
      )
    }
  },
  mounted() {
    this.$nextTick(function () {
      if (this.$refs.intent) {
        this.$refs.intent.updateOptions({
          colors: this.intentSeries.color,
          labels: this.intentSeries.label
        })
      }
    })
  },
  methods: {
    openIntentDetail: function (intentName) {
      var vm = this
      vm.currentIntent = intentName
      vm.loadingIntent = true
      vm.getTrainingConversation()
      vm.showIntent = true
    },
    getTrainingConversation: function () {
      var vm = this
      var data = {
        pageid: vm.selectedBot.pageid,
        intentname: vm.currentIntent,

        datefrom: moment(this.date.start).format('YYYY-MM-DD'),
        dateto: moment(this.date.end).format('YYYY-MM-DD'),
        app: this.filter
      }
      vm.loadingIntent = true
      api.getGroupDefaultChatlogs(data, function (error, response) {
        if (error) {
          console.error(error)
          vm.loadingIntent = false
          return
        }

        if (response.data) {
          vm.intentDetails = response.data
        }
        vm.loadingIntent = false
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/report/ReportMessageGraph.vue